export var E_AI_TAGGING_TOUR_STEP;
(function (E_AI_TAGGING_TOUR_STEP) {
    E_AI_TAGGING_TOUR_STEP["START"] = "START";
    E_AI_TAGGING_TOUR_STEP["SELECT_FIELD"] = "SELECT_FIELD";
    E_AI_TAGGING_TOUR_STEP["NODE_PARSING"] = "NODE_PARSING";
    E_AI_TAGGING_TOUR_STEP["FIELD_SETTING"] = "FIELD_SETTING";
    E_AI_TAGGING_TOUR_STEP["CHECK_RESULT"] = "CHECK_RESULT";
})(E_AI_TAGGING_TOUR_STEP || (E_AI_TAGGING_TOUR_STEP = {}));
export var E_AI_TAGGING_TOUR_STATUS;
(function (E_AI_TAGGING_TOUR_STATUS) {
    E_AI_TAGGING_TOUR_STATUS["PROCESS"] = "process";
    E_AI_TAGGING_TOUR_STATUS["FINISHED"] = "finished";
})(E_AI_TAGGING_TOUR_STATUS || (E_AI_TAGGING_TOUR_STATUS = {}));
